import {
  SUBMIT_TAX_RATE_CHANGES,
  SUBMIT_TAX_RATE_CHANGES_SUCCESS,
  SUBMIT_TAX_RATE_CHANGES_FAILED,
  FETCH_TAX_RATE_CHANGES,
  FETCH_TAX_RATE_CHANGES_SUCCESS,
  FETCH_TAX_RATE_CHANGES_FAILED,
} from './types';
import { submitTaxEntries as submitTaxEntriesApi } from '../../api';
import { fetchTaxRateChanges as fetchTaxRateChangesApi } from '../api';

import { errorNotification, successNotification } from '../../../shared/store/notificationActions';
import { showAlert, hideAlert, fetchingError } from '../../../shared/store/actions';
import alertTypes from '../../../shared/alertTypes';

export const fetchTaxRateChanges = periodName => async dispatch => {
  dispatch({ type: FETCH_TAX_RATE_CHANGES });

  try {
    const taxRateChanges = await fetchTaxRateChangesApi(periodName);

    dispatch({
      type: FETCH_TAX_RATE_CHANGES_SUCCESS,
      taxRateChanges,
    });
    // hack to prevent grid losing data after the first submit
    dispatch(showAlert('', alertTypes.SUCCESS));
    dispatch(hideAlert());
  } catch (error) {
    dispatch({
      type: FETCH_TAX_RATE_CHANGES_FAILED,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const submitRateChanges = (rateChangeEntries, periodName, taxYear) => async dispatch => {
  dispatch({
    type: SUBMIT_TAX_RATE_CHANGES,
  });

  if (rateChangeEntries.length === 0) {
    dispatch(showAlert('No rate change entry(s) are selected.', alertTypes.DANGER));
    dispatch({
      type: SUBMIT_TAX_RATE_CHANGES_FAILED,
    });
    return;
  }

  try {
    await submitTaxEntriesApi(rateChangeEntries.map(({
      defAccountNumber,
      newRate,
      rateChangeEntry,
      currencyCode,
      ...entry
    }) => ({
      ...entry,
      periodName,
      taxYear,
      account: defAccountNumber,
      currency: currencyCode,
      entryActivity: 'RATE-CHG',
      entryType: 'DEF',
      grossFlag: false,
      netAmount: parseFloat(rateChangeEntry),
      taxRate: newRate,
      topsideFlag: false,
      batchId: 'RChWP',
    })));

    dispatch({
      type: SUBMIT_TAX_RATE_CHANGES_SUCCESS,
    });
    dispatch(successNotification(`${rateChangeEntries.length} rate change tax entries submitted.`));
  } catch (error) {
    dispatch({
      type: SUBMIT_TAX_RATE_CHANGES_FAILED,
    });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
    }
  }
};
